module.exports = __webpack_public_path__ + "static/img/sl01.c445b77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sl01.jpg
// module id = n0iI
// module chunks = 0